// styles
import {
  FloatHeroBoxWrapper,
  Container,
  Title,
  Subtitle,
  Button,
} from './FloatHeroBox.styles';

export function FloatHeroBox() {
  return (
    <FloatHeroBoxWrapper>
      <Container>
        <Title>
          A simple and powerful dock scheduling solution for your warehouse.
        </Title>
        <Subtitle>
          Warehouses trust Loadsmart to improve their dock operations.
          Experience improved employee utilization and automated reporting to
          monitor your warehouse’s dwell time and carrier’s on-time performance.
        </Subtitle>
        <Button
          href={`${process.env.OPENDOCK_URL}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Lower Your Facility Dwell Time
        </Button>
      </Container>
    </FloatHeroBoxWrapper>
  );
}
